import { BaseGraphQL } from "~/services/baseGraphQL";
import { GRAPHQL_AUTHENTICATION } from "~/constants/url";
import { JsonResponseType } from "~/types/jsonResponseType";
import { AzureSSOSettings } from "../types/ssoConfiguration";

const authenticationGraph = BaseGraphQL({
  baseUrl: GRAPHQL_AUTHENTICATION,
});

export const getAzureSSOSettings = async () => {
  const query = `
         query {
      authenticate {
        getAzureSSOSettings {
          messageCode
          succeed
          data {
              clientId
              tenantId
              redirectUri
              authority
              isMultiTenant
            }
          }
      }
    }
  `;

  return await authenticationGraph<
    AzureSSOSettings,
    {
      authenticate: {
        getAzureSSOSettings: JsonResponseType<AzureSSOSettings>;
      };
    }
  >(
    {
      action: "UserGraphQL",
      query,
      variables: {},
    },
    (input) => input.authenticate.getAzureSSOSettings,
  );
};
